import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import FormRadioGroup from '../form/FormRadioGroup';
import QuestionHeader from './QuestionHeader';
import { Typography } from '@material-ui/core';
import FormImagePickerGroup from '../form/FormImagePickerGroup';

const SubmissionSingleChoice = ({ name, number, questionText, answers, readonly, isOptional, allowOwnAnswer, ownAnswerName, displayImages, surveyId, tenant }) => (
  <div className="box">
    <div className="col-sm-12">
      <QuestionHeader name={questionText} number={number} />
      {isOptional && <Typography variant="caption" color="textSecondary">Odpowiedź nie jest wymagana</Typography>}
      <div>
        <Field
          name={`${name}.selectedAnswersIds[0]`}
          component={displayImages ? FormImagePickerGroup : FormRadioGroup}
          values={answers.map(answer => ({ value: answer.id, name: answer.answerText, imageUrl: answer.image ? `https://konsultacjejst.blob.core.windows.net/consultations-survey-question-uploads/${tenant}/${surveyId}/${answer.image.fileId}` : null }))}
          disabled={readonly}
          allowOwnAnswer={allowOwnAnswer}
          ownAnswerName={ownAnswerName}
          ownAnswerFieldName={`${name}.ownAnswers[0]`}
        />
      </div>
    </div>
  </div>
);

SubmissionSingleChoice.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired,
  answers: PropTypes.array.isRequired,
  readonly: PropTypes.bool,
  isOptional: PropTypes.bool,
  allowOwnAnswer: PropTypes.bool,
  ownAnswerName: PropTypes.string,
  displayImages: PropTypes.bool,
  surveyId: PropTypes.string,
  tenant: PropTypes.string,
};

export default SubmissionSingleChoice;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/SubmissionSingleChoice.js